<template>
	<div class="modal">
		<el-dialog
			:visible="visible"
			:top="top"
			:width="width"
			:lock-scroll="true"
			:close-on-click-modal="false"
			:title="title"
			@close="onCancel"
			:destroy-on-close="destroyOnClose"
		>
			<slot v-if="visible" />
			<span v-if="footer" slot="footer" class="dialog-footer">
				<el-button @click="onCancel">取消</el-button>
				<el-button type="primary" :loading="loading" @click="onSubmit">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: 'modal',
	props: {
		title: {
			type: String,
			default: ''
		},
		top: {
			type: String,
			default: '10vh'
		},
		width: {
			type: String
		},
		visible: {
			type: Boolean,
			default: false
		},
		destroyOnClose: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		footer: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onCancel() {
			this.$emit('cancel');
		},
		onSubmit() {
			this.$emit('submit');
		}
	}
};
</script>
<style lang="scss">
.modal {
	.el-dialog__header {
		// background-color: @theme-color;
		padding: 18px 24px;
		line-height: 1px;

		.el-dialog__title {
			color: #333333;
		}
	}

	.el-dialog__body {
		padding: 24px;
		background-color: #FFFFFF;
	}

	.el-dialog__footer {
		padding: 0 24px 24px;
	}
}
</style>
